<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  computed: {
    args() {
      return this.$store.getters.args;
    },
  },
  watch: {
    args: {
      deep: true,
      handler(args) {
        this.handleInit(args);
      },
    },
  },
  created() {
    let hash = window.localStorage.getItem("catalogUrl");
    if (hash && hash != "false") {
      window.localStorage.setItem("catalogUrl", false);
      window.location.hash = hash;
    } else {
      this.handleInit();
    }

    // this.$router.push(route).catch((err) => {});
  },
  methods: {
    handleInit(args = {}) {
      let route = {
        name: "Catalog",
        query: {},
      };

      route.query.page = args.paged;

      route.query.category = args.category ? args.category : null;

      route.query.tag = args.tag ? args.tag : null;

      if (args.search) {
        route.query.search = args.search;
      }

      this.$router.push(route).catch((err) => {});
    },
  },
};
</script>

<style lang="scss">
@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

// Loader
.loader {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 300px;

  &::after {
    content: "";
    display: block;
    width: 100px;
    height: 100px;
    border: 10px solid whitesmoke;
    border-top-color: black;
    border-radius: 50%;
    animation: rotate 0.75s infinite linear;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue